<template>
  <div class="lds-ring loading">
    <div></div><div></div><div></div><div></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
}
</script>

<style lang="sass">
.loading.lds-ring {
  display: inline-block;
  position: absolute;
  z-index:1000;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(242,240,235, 0.75);
}

.lds-ring {
  display: none;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 4px solid #FF6753;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #FF6753 transparent transparent transparent;
  left: 45%;
  top: 40%;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>